<template>
    <FormAddResponse v-if="post.isUserResponding" :post="post" :answer-snippet="answerSnippet" />
    <div v-else class="response">
        <a v-if="hasAnswers" href="#" @click.prevent="toggleAnswerList">
            {{ isAnswerListOpen ? $t('discussions.closeAnswer', post.answers.length) : $t('discussions.open', post.answers.length) }}
        </a>
        <a href="#" class="response__add" @click.prevent="toggleAnswerRespondState">
            {{ $t('discussions.respond') }}
        </a>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import PostModel from '~/models/Discussion/Post'
import FormAddResponse from '~/components/objects/Discussion/Response/FormAddResponse.vue'
import { useBasketStore } from '~/stores/basket'

export default {
    components: {
        FormAddResponse,
    },
    props: {
        post: {
            type: Object as PropType<PostModel>,
            default: null,
            required: false,
        },
        isAnswerListOpen: {
            type: Boolean,
            default: false,
            required: false,
        },
        answerSnippet: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            banned: false,
        }
    },
    computed: {
        authUser(): object | null {
            const basketStore = useBasketStore()
            return basketStore.authUser
        },
        hasAnswers(): boolean {
            return this.post.answers && this.post.answers.length > 0
        },
    },
    methods: {
        toggleAnswerList() {
            useNuxtApp().$bus.$emit('toggleAnswerList', this.post.id)
        },
        isUserAuthenticated() {
            return this.authUser !== null
        },
        toggleAnswerRespondState() {
            if (this.isUserAuthenticated() && !this.banned) {
                useNuxtApp().$bus.$emit('toggleRespond', this.post.id)
            } else {
                useNuxtApp().$bus.$emit('openModalForLogin')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.response {
    margin: 0.5rem 0 1rem;
    padding: 0;
    font-size: 14px;
    color: $color-grey-extra-dark;
    text-transform: lowercase;
    gap: 20px;
    display: flex;

    &__add {
        color: $color-grey-semi-dark;
    }
}
</style>
